module.exports = __webpack_public_path__ + "r-v3/img/ml_144_00.93619a47.jpg";